import { SALARIES_API_ENDPOINT_ROOT } from 'modules/salaries/utils/constants/salariesApiEndpointRoot';
import { getJson } from 'utils/http/getJson';

type JobSibling = {
  description: string;
  family: { id: string; name: string };
  id: string;
  level: number;
  name: string;
  subFamily: { id: string };
  synonyms: {
    id: string;
    name: string;
  }[];
};

export function salariesFetchSynonyms(id: string): Promise<{
  jobTitle: JobSibling;
  subFamilyJobTitles: JobSibling[];
}> {
  return getJson(`${SALARIES_API_ENDPOINT_ROOT}/job-titles/${id}`);
}
